const INTERNAL_PARAMS = ['brand', 'pixelId', 'pixelOff', 'state', 'gtmId'];

export function buildTrackedUrl(baseUrl: string): string {
  const queryParams = new URLSearchParams(window.location.search);
  INTERNAL_PARAMS.forEach((p) => queryParams.delete(p));
  const queryString = queryParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
